<template>
  <div class="mask">
    <div class="drawRule">
      <div class="box">
        <div class="title">Cuenta Atrás Para El Sorteo</div>
        <div class="zj-list-box">
          <div class="zj-list" :class="className">
            <div class="item" v-for="(item, index) in result" :key="index">
              <img :src="prizeName" alt="" class="image">
              {{ item?.winnerName || item }}
            </div>
          </div>
          <div class="zj-list-mobile" :class="classNameM">
            <div class="item" v-for="(item, index) in result" :key="index">
              <img :src="prizeName" alt="" class="image">
              {{ item?.winnerName || item }}
            </div>
          </div>
        </div>
        <div class="btn" @click="closeResult">Confirmar</div>
      </div>
    </div>
    <Fireworks :mode="fireworksMode" :active="showFireworks" />
  </div>
</template>
<script setup>
import { ref, computed } from 'vue'
  import Fireworks from '@/components/Fireworks.vue'
  const emit = defineEmits(['closeResult'])
  const prop = defineProps({
    result: {
      type: Array,
      default: () => []
    },
    prizeName: {
      type: String,
      default: ''
    }
  })
const className = computed(() => {
  if(prop.result.length <= 4) {
    return 'grid-cols-'+prop.result.length
  }else {
    return 'grid-cols-4'
  }
})
const classNameM = computed(() => {
  if(prop.result.length <= 3) {
    return 'grid-cols-m-'+prop.result.length
  }else {
    return 'grid-cols-m-3'
  }
})
const fireworksMode = ref('center') // center | aside | random | none
const showFireworks = ref(false)
  function onWin() {
    showFireworks.value = true
    // 3 秒后停止发射新烟花，已发射的会继续播放完
    setTimeout(() => {
      showFireworks.value = false
    }, 3000)
  }
  onWin()
  const closeResult = () => {
    emit('closeResult')
  }
</script>
<style scoped lang="scss">
.box {
  width: 100%;
  border-radius: 20px;background: linear-gradient(180deg, #C6E7FF 0%, #5FC1FF 100%);
  border: 2px solid #FFFFFF;
  box-shadow: 0px 4px 20px 0px #FFFFFFCC;
  box-sizing: border-box;
  padding: 50px 30px 30px;
  position: relative;
}
.mask {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.85);
  .drawRule {
    width: 100%;
    max-width: 1080px;
    max-height: 88vh;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    overflow: hidden;
    overflow-y: auto;
    /* 针对 Firefox 浏览器 */
    scrollbar-width: none;
    /* 针对 IE 和 Edge 浏览器 */
    -ms-overflow-style: none;
    /* 针对 Chrome、Safari 和 Opera 浏览器 */
    ::-webkit-scrollbar {
      display: none; /* 完全隐藏滚动条 */
    }
    padding-top: 25px;
    .zj-list-box {
      display: flex;
      justify-content: center;
    }
    .zj-list-mobile{
      display: none;
    }
    .zj-list {
      display: grid;
      margin-top: 40px;
      .item {
        display: flex;
        flex-direction: column;
        align-items: center;
        font-size: 22px;
        text-align: center;
        .image {
          width: 200px;
          height: 200px;
          margin-bottom: 20px;
          background-color: #fff;
          border-radius: 18px;
        }
      }
    }
    .btn {
      width: 284px;
      height: 75px;
      text-align: center;
      line-height: 75px;
      background: url("@/assets/images/bg-title-btn1.png") center center no-repeat;
      background-size: 100% 100%;
      font-size: 24px;
      color: #ffffff;
      margin: 20px auto 0;
    }
  }
}
@media screen and (max-width: 768px) {
  .mask {
    .drawRule {
      padding-top: 20px;
      .zj-list {
        display: none;
      }
      .box{
        width: 92%;
        margin: 0 auto;
        padding: 45px 20px 20px;
      }
      .zj-list-mobile {
        display: grid;
        margin-top: 25px;
        .item {
          font-size: 12px;
          text-align: center;
          display: flex;
          flex-direction: column;
          align-items: center;
          .image {
            width: 92px;
            height: 92px;
            margin-bottom: 20px;
            background-color: #fff;
            border-radius: 8px;
          }
        }
      }
      .btn {
        width: 194px;
        height: 50px;
        font-size: 16px;
        line-height: 50px;
        margin-top: 25px;
      }
    }
  }
}
.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 20px;
}
.grid-cols-3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 20px;
}
.grid-cols-4 {
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 20px;
}
.grid-cols-5 {
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 20px;
}
.grid-cols-6 {
  grid-template-columns: repeat(6, minmax(0, 1fr));
  gap: 20px;
}
.grid-cols-m-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
  gap: 15px;
}
.grid-cols-m-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 15px;
}
.grid-cols-m-3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 15px;
}
.title {
  width: 405px;
  height: 74px;
  background: url("@/assets/images/bg-title-btn.png") center center no-repeat;
  background-size: 100% 100%;
  text-align: center;
  line-height: 74px;
  font-size: 24px;
  font-weight: bold;
  color: #fff;
  position: absolute;
  top: -25px;
  left: 50%;
  transform: translateX(-50%);
}
@media screen and (max-width: 768px) {
  .title {
    width: 266px;
    height: 62px;
    line-height: 62px;
    top: -20px;
    font-size: 16px;
  }
}
</style>
